// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ng-c";
export var backButton = "_ng-4";
export var backIcon = "_ng-5";
export var chevronShortcut = "_ng-6";
export var container = "_ng-1";
export var editor = "_ng-8";
export var editorWrapper = "_ng-7";
export var prefix = "_ng-2";
export var searchIcon = "_ng-3";
export var suffix = "_ng-9";
export var suffixContent = "_ng-a";
export var suffixText = "_ng-b";
export var wrapper = "_ng-0";